<template>
    <!--专项课程 -->
    <div class="member">
        <div class="title-warp flex-align">
            <h3 class="title">Part1</h3>
            <span class="subtitle">基于工具与平台的互动式学习</span>
        </div>
        <ul class="member-list flex-layout">
            <li v-for="(item,index) in memberList" :key="index" class="member-item">
                <img :src="item.icon" alt="" class="member-avatar">
                <div class="info">
                    <p class="member-name">{{item.name}}</p>
                    <el-rate v-model="item.star" :colors="['#1E85E4', '#1E85E4', '#1E85E4']" disabled></el-rate>
                </div>
            </li>
        </ul>
        <div class="title-warp flex-align">
            <h3 class="title">Part2</h3>
            <span class="subtitle">课程实录</span>
        </div>
        <div class="video-warp">
            <video class="video" src="" poster="../../assets/studio/image-6.png"></video>
        </div>
        <ul class="video-list flex-layout">
            <li v-for="(item,index) in 3" :key="index" class="video-item">
                <video class="each-video" src="" poster="../../assets/studio/image-6.png"></video>
                <p class="video-info flex-align-between">
                    <span class="video-name">xxx课程</span>
                    <span class="video-duration">30"28'</span>
                </p>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                pages: { //分页
                    currentPage: 1,
                    pageSize: 8,
                    total: 30,
                },
                memberList: [{
                        icon: require("../../assets/studio/icon-13.png"),
                        name: '数字教材',
                        star: 5
                    },
                    {
                        icon: require("../../assets/studio/icon-14.png"),
                        name: '数字xxx',
                        star: 5
                    }, {
                        icon: require("../../assets/studio/icon-15.png"),
                        name: '数字xxx',
                        star: 5
                    }
                ]
            }
        }
    }
</script>

<style lang="less" scoped>
    .title-warp {
        padding-bottom: 14px;
    }

    .title {
        background-color: #6B8EEB;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        font-size: 24px;
        line-height: 2.1;
        color: #fff;
        font-weight: bold;
        padding: 0 3.7% 0 6.2%;
        box-sizing: border-box;
        position: relative;

        &::before {
            content: " ";
            width: 28px;
            height: 48px;
            background-image: url("../../assets/studio/Icon_Bookmark.png");
            background-repeat: no-repeat;
            position: absolute;
            top: 0;
            left: 14px;
        }
    }

    .subtitle {
        font-size: 34px;
        margin-left: 3%;
    }

    .member-list {
        padding: 5% 0 5%;
        background-image: url("../../assets/studio/course-bg.png");
        margin-bottom: 35px;

        .member-item {
            margin-bottom: 4.1%;
            width: 33.33%;
            text-align: center;
        }

        .member-avatar {
            flex-shrink: 0;
        }

        .member-name {
            font-size: 24px;
            margin-top: 36px;
            margin-bottom: 13px;
        }
    }

    .video-warp {
        margin-top: 55px;
        text-align: center;
        position: relative;

        &::before,
        &::after {
            content: " ";
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            height: 90%;
            width: 107px;
            background-image: url("../../assets/studio/image-5.png");
            background-repeat: no-repeat;
        }

        &::after {
            left: auto;
            right: 0;

        }

        .video {
            position: relative;
        }
    }


    .video-list {
        margin-top: 97px;

        .video-item {
            margin-right: 61px;
            width: 335px;
            height: 260px;
            position: relative;

            &:last-child {
                margin-right: 0;
            }

            .each-video {
                width: 100%;
                height: 100%;
            }
        }

        .video-info {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 335px;
            padding: 0 28px;
            line-height: 3.33;
            font-size: 18px;
            background-color: rgba(0, 0, 0, .55);
            color: #fff;
            box-sizing: border-box;
        }
    }
</style>